module.exports = __webpack_public_path__ + "img/treasury_03.0b9c1af5.png";